// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1Agrg","detailsBorder":"styles_detailsBorder__2lQ93"};